<template>
  <popup
    :opened="dataToShow"
    @close="close"
  >
    <!-- BEGIN Content modal add referent -->
    <div>
      <div class="my-5 mx-5 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32 text-center">
        <h3 class="mb-10">
          Supprimer la catégorie « {{ category }} »
        </h3>

        <p class="text-indigo-600 text-lg">
          Êtes-vous sûr de vouloir supprimer la catégorie « {{ category }} » ?
        </p>

        <div class="mt-5 text-red-500 text-sm text-center">
          {{ ((errors || [])['forbidden'] || [])[0] }}
        </div>

        <div class="flex justify-center space-x-5 mt-10">
          <action-button
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-100"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Annuler"
            :uppercase="true"
            @clickAction="close()"
          />
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            :bg-color="saving ? 'bg-gray-600' : 'bg-pink-600'"
            :bg-color-square="saving ? 'bg-gray-600' : 'bg-pink-600'"
            libelle="Supprimer"
            :uppercase="true"
            :type-shadow="saving ? 'shadow-gray' : 'shadow-pink'"
            @clickAction="deleteCategory(category)"
          />
        </div>
      </div>
    </div>
    <!-- END Content modal add referent -->
  </popup>
</template>

<script>
import Popup from './../Popup';
import ActionButton from './../ActionButton';
import InputText from './../Inputs/InputText';
import Icon from './../Icon';

export default {
  name:'DeleteCategoryPopup',

  props:{
    dataToShow: Boolean,
    category:String,
    saving:{
      type:Boolean,
      required:false,
      default:false,
    },
    errors:Object,
  },

  data() {
    return {
      //
    };
  },

  components:{
    Popup,
    ActionButton,
    InputText,
    Icon
  },

  methods:{

    close(){
      this.$emit('close');
    },

    deleteCategory(category){
      this.$emit('deleteCategory', category);
    },
  }
};
</script>
